// src/components/Footer.jsx
import React, { useContext } from 'react';
import { AppContext } from './AppContext';

export default function Footer() {
    const {
        settings: {
            agent_rera,
            facebook_link,
            instagram_link,
            linkedin_link,
            youtube_link,
            twitter_link,
            whatsapp_link,
            gmail_link,
            phone_link,
            brand_name,
            disclaimer,
        } = {},
    } = useContext(AppContext);

    const currentYear = new Date().getFullYear();

    const socials = [
        { url: facebook_link, class: 'fab fa-facebook-f', hover: 'hover:text-blue-500' },
        { url: instagram_link, class: 'fab fa-instagram', hover: 'hover:text-pink-500' },
        { url: linkedin_link, class: 'fab fa-linkedin-in', hover: 'hover:text-blue-700' },
        { url: youtube_link, class: 'fab fa-youtube', hover: 'hover:text-red-600' },
        { url: twitter_link, class: 'fab fa-twitter', hover: 'hover:text-blue-400' },
    ];

    return (
        <footer
            className="bg-gray-800 text-white text-center py-8"
            style={{ fontFamily: "'Rubik', sans-serif" }}
        >
            {/* Social Links */}
            <div className="mb-4 flex justify-center flex-wrap gap-4">
                {socials.map(({ url, class: iconClass, hover }, i) =>
                    url ? (
                        <a
                            key={i}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`text-white text-2xl ${hover}`}
                        >
                            <i className={iconClass}></i>
                        </a>
                    ) : null
                )}

                {whatsapp_link && (
                    <a
                        href={`https://wa.me/${whatsapp_link}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white text-2xl hover:text-green-500"
                    >
                        <i className="fab fa-whatsapp"></i>
                    </a>
                )}

                {gmail_link && (
                    <a
                        href={`mailto:${gmail_link}`}
                        className="text-white text-2xl hover:text-red-500"
                    >
                        <i className="fas fa-envelope"></i>
                    </a>
                )}

                {phone_link && (
                    <a
                        href={`tel:+${phone_link}`}
                        className="text-white text-2xl hover:text-yellow-400"
                    >
                        <i className="fas fa-phone text-[1.2rem]"></i>
                    </a>
                )}
            </div>

            {/* RERA & Links */}
            <div className="text-sm">
                <p className="m-2">RERA Registration No – {agent_rera}</p>

                {/* Desktop */}
                <p className="hidden md:flex justify-center space-x-4">
                    <a
                        href="/terms-of-service"
                        className="hover:underline hover:text-white"
                    >
                        Terms of Service
                    </a>
                    <span>|</span>
                    <a
                        href="/privacy-policy"
                        className="hover:underline hover:text-white"
                    >
                        Privacy Policy
                    </a>
                    <span>|</span>
                    <span>© {currentYear} {brand_name}</span>
                </p>

                {/* Mobile */}
                <div className="md:hidden space-y-2">
                    <a
                        href="/terms-of-service"
                        className="block hover:underline"
                    >
                        Terms of Service
                    </a>
                    <a
                        href="/privacy-policy"
                        className="block hover:underline"
                    >
                        Privacy Policy
                    </a>
                    <span className="block">© {currentYear} {brand_name}</span>
                </div>
            </div>

            {/* Disclaimer */}
            <p className="text-xs mt-4 px-2">
                The logos are registered trademarks of respective owners. This product is not endorsed or approved by the organizations.
            </p>
            <p className="text-xs mt-1 px-4 lg:px-20 text-justify">
                {disclaimer}
            </p>

        </footer>
    );
}
